"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateAriaLabel = void 0;
var _getPriceOrRange = require("./getPriceOrRange");
/**
 * Generates an ARIA label string based on the given price values.
 *
 * @param was - The previous price.
 * @param then1 - The first intermediate price.
 * @param then2 - The second intermediate price.
 * @param now - The current price.
 * @param pricePrefix - A prefix for the price.
 * @param priceSuffix - A suffix for the price.
 * @returns The generated ARIA label string.
 */
var generateAriaLabel = exports.generateAriaLabel = function generateAriaLabel(was, then1, then2, now) {
  var pricePrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var priceSuffix = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var steps = [];
  var wasPrice = (0, _getPriceOrRange.getPriceOrRange)(was);
  var then1Price = (0, _getPriceOrRange.getPriceOrRange)(then1);
  var then2Price = (0, _getPriceOrRange.getPriceOrRange)(then2);
  var nowPrice = (0, _getPriceOrRange.getPriceOrRange)(now);
  if (wasPrice) {
    steps.push("The price was ".concat(wasPrice));
  }
  if (then1Price) {
    steps.push("then ".concat(then1Price));
  }
  if (then2Price) {
    steps.push("then ".concat(then2Price));
  }
  if (nowPrice) {
    var priceText = "".concat(pricePrefix !== null && pricePrefix !== void 0 ? pricePrefix : '', " ").concat(nowPrice, " ").concat(priceSuffix !== null && priceSuffix !== void 0 ? priceSuffix : '').trim();
    if (steps.length === 0) {
      steps.push("The price is ".concat(priceText));
    } else {
      steps.push("now ".concat(priceText));
    }
  }
  return steps.join(', ');
};